import {Fragment } from "react"
import {SkipDays} from "../../calendarBuilder"


export const June = () => {
    return (
        <Fragment>{SkipDays(1, 2, [25, 26, 27, 28, 29, 30], false)}</Fragment>  
    )
}